import type { FileWithPath } from '@mantine/dropzone'
import { cva } from 'class-variance-authority'
import type { FC } from 'react'

import type { UploadFilesListProps } from './UploadFilesList.types'
import { UploadFileItem } from './subs/UploadFileItem'

const dropzoneFileListCVA = {
  root: cva(['flex w-full flex-col gap-y-2'])
}

export const UploadFilesList: FC<UploadFilesListProps> = ({
  value,
  className,
  onChange,
  disabled,
  allowDelete = true,
  size = 'm'
}) => {
  const handleDelete = (item: FileWithPath) => {
    const arr = [...value]
    const index = arr.findIndex(file => file.name === item.name)
    arr.splice(index, 1)

    return onChange?.(arr)
  }

  return (
    <div className={dropzoneFileListCVA.root({ className })}>
      {(value || []).map((file, index) => (
        <UploadFileItem
          allowDelete={allowDelete}
          key={index}
          size={size}
          file={file}
          onDelete={handleDelete}
          disabled={disabled}
        />
      ))}
    </div>
  )
}
